import { ToastService } from 'src/app/services/toast.service';
import { ContenidoStatus } from './../../../../../common/contenido';
import { destacadoMaxQtyToLoad, destacadoStatus } from './destacado.selectors';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ContenidoService } from '../../services/contenido.service';
import { DestacadoPageLoaded, DestacadoPageRequested, DestacadoActionTypes, DestacadoPageRight, DestacadoPageCancelled } from './destacado.actions';
import { mergeMap, map, withLatestFrom, catchError, switchMap } from 'rxjs/operators';
import { Action, Store } from '@ngrx/store';
import { of, Observable } from 'rxjs';
import { AppState } from 'src/app/reducers';

@Injectable()
export class DestacadoEffects {

	private readonly FIRST_PAGE: number = 0;

	loadDestacado$ = createEffect( () => {
		return this.actions$.pipe(
			ofType<DestacadoPageRequested>( DestacadoActionTypes.DestacadoPageRequested ),
			switchMap( action => {
				return this.service.findDestacadoStatus().pipe(
					map( remoteStatus => {
						return { action, remoteStatus };
					}),
					catchError( error => of( { action, remoteStatus: null } ) )
				);
			}),
			withLatestFrom( this.store.select( destacadoStatus ), this.store.select( destacadoMaxQtyToLoad ) ),
			switchMap( ([ data, localStatus, maxQtyToLoad ]) => {
				let resultAction: Observable<Action>;
				let shouldLoadContent: boolean = false;
				let remoteStatus: ContenidoStatus = data["remoteStatus"];
				let cleared: boolean = false;

				if( remoteStatus == null ) {
					resultAction = of( new DestacadoPageCancelled( { status: null } ) );
					this.toastService.danger( "No se pudo obtener el estado de las noticias destacadas" );
				} else {
					// Hay actualizaciones nuevas?
					if(
						( localStatus && localStatus.lastUpdate && localStatus.qty >= 0 ) &&
						( localStatus.lastUpdate.getTime() != remoteStatus.lastUpdate.getTime() || localStatus.qty != remoteStatus.qty )
				 	) {
						cleared = true;
					}

					// Se carga el componente por primera vez?
					if( !localStatus )
						shouldLoadContent = true;

					if( remoteStatus.qty == 0 ) {
						resultAction = of( new DestacadoPageLoaded({ cleared, status: remoteStatus, destacado: [] }) );
					} else if( cleared || shouldLoadContent ) {
						resultAction = this.service.findDestacadoByPage( { pageNum: this.FIRST_PAGE, pageSize: maxQtyToLoad } )
							.pipe(
								map( destacado => {
									// Destacado debería siempre tener elementos en esta instancia =>
									// dado que remoteStatus.qty > 0
									return destacado.length == 0 ?
										new DestacadoPageCancelled( { status: localStatus } ) :
										new DestacadoPageLoaded( { cleared, status: remoteStatus, destacado } )
								}),
								catchError( error => {
									// Si no pude recuperar los nuevos destacados, me quedo con el status local, no actualizo al nuevo (remoteStatus)
									// El status y los destacados del store deben estar sincronizados
									this.toastService.danger( "No se pudieron obtener noticias destacadas" );
									return of( new DestacadoPageCancelled( { status: localStatus } ) );
								})
							);
					} else {
						// No hubieron cambios en los destacados
						resultAction = of( new DestacadoPageRight() );
					}
				}

				return resultAction;
			})
		);
	});


	constructor( private actions$: Actions, private store: Store<AppState>, private service: ContenidoService, private toastService: ToastService ) {
	}

}